import React, { useContext, useState, useEffect } from "react";
import { Form, Input, Button } from "antd";
import { CheckOutlined, CloseOutlined, UserOutlined } from "@ant-design/icons";
import { TResponseModel } from "../../types/config";
import { useNavigate } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { eFONTFAMILY, eResultCode } from "../../utils/enum";
import useToast from "../../hooks/useToast";
import { ToastOpen, ToastType } from "../../state/toast/slice";
import styles from "./auth.module.css";
import { UserContext } from "../../context";
import EncryptUtils from "../../utils/encrypt";
import { ResetPassword } from "../../utils/api.constant";

type TProps = {
  handleModalCancel?: () => void;
};

const SendOTP: React.FC<TProps> = ({ handleModalCancel }) => {
  const context: any = useContext(UserContext);
  const navigate = useNavigate();
  const { post } = useFetch();
  const { onShowToast } = useToast();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [form] = Form.useForm();

  const onSubmitNewPassword = async (values: {
    previousPassword: string;
    newPassword: string;
  }) => {
    try {
      setIsLoading(true);
      const encryptedPreviousPassword = EncryptUtils.encrypt(
        values.previousPassword as string
      );
      const encryptedNewPassword = EncryptUtils.encrypt(
        values.newPassword as string
      );

      const payload = {
        data: {
          previousPassword: encryptedPreviousPassword,
          newPassword: encryptedNewPassword,
        },
      };

      const response: TResponseModel = await post(ResetPassword, payload);

      const { dataResponse } = response;
      const { returnCode, description } = dataResponse;

      if (returnCode === eResultCode.SUCCESS) {
        onShowToast({
          type: ToastType.success,
          title: <CheckOutlined />,
          position: ToastOpen.centerTop,
          content: description,
        });
        handleModalCancel ? handleModalCancel?.() : navigate("/login");
      } else {
        onShowToast({
          type: ToastType.error,
          title: <CloseOutlined />,
          position: ToastOpen.centerTop,
          content: description,
        });
      }
    } catch (error) {
      console.error("Error submitting new password:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Form name="newPassword" onFinish={onSubmitNewPassword} size="middle">
      <Form.Item
        name="previousPassword"
        rules={[
          { required: true, message: "Please input your previous password!" },
        ]}
      >
        <Input.Password placeholder="Previous Password" />
      </Form.Item>
      <Form.Item
        name="newPassword"
        rules={[
          { required: true, message: "Please input your new password!" },
          {
            pattern:
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
            message:
              "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character!",
          },
        ]}
      >
        <Input.Password placeholder="New Password" />
      </Form.Item>
      <Form.Item>
        <Button block type="primary" htmlType="submit" loading={isLoading}>
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SendOTP;
